import { AxiosRequestConfig } from 'axios';

export const emailReceiverKeys = {
  email_receiver: (params?: AxiosRequestConfig) =>
    ['EMAIL_RECEIVER', params] as const,
};
